import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-156c065d")

_pushScopeId("data-v-156c065d")
const _hoisted_1 = { class: "award-store-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", null, "奖品库", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "list-title" }, [
  /*#__PURE__*/_createVNode("span", null, "奖品预览")
], -1)
const _hoisted_4 = { class: "list-wrapper" }
const _hoisted_5 = { class: "list-item-info" }
const _hoisted_6 = { class: "list-bottom" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")
  const _component_Back = _resolveComponent("Back")
  const _component_Action = _resolveComponent("Action")
  const _component_PopInner = _resolveComponent("PopInner")

  return (_openBlock(), _createBlock(_component_PopInner, null, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Title, { text: `幸运抽奖` }),
        _createVNode(_component_Back, { onAction: _ctx.goBack }, null, 8, ["onAction"]),
        _createVNode("div", {
          class: "rule-wrapper",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goStore && _ctx.goStore(...args)), ["stop","prevent"]))
        }, [
          _hoisted_2
        ]),
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (i, k) => {
            return (_openBlock(), _createBlock("div", {
              class: "list-item",
              key: k
            }, [
              _createVNode("div", _hoisted_5, [
                _createVNode("img", {
                  src: i.img
                }, null, 8, ["src"]),
                _createVNode("div", _hoisted_6, [
                  _createVNode("span", null, _toDisplayString(i.title), 1)
                ])
              ])
            ]))
          }), 128))
        ]),
        _createVNode(_component_Action, {
          class: "action-wrapper",
          text: `抽奖*${_ctx.awardCount}`,
          onAction: _ctx.goDraw
        }, null, 8, ["text", "onAction"])
      ])
    ]),
    _: 1
  }))
})